import { ROUTER_API } from 'app/constants/api.constant';
import { ConversionRateDTO } from 'app/main/apps/franchises/type';
import { ListObject } from 'app/main/design-system/models/listObjectsModel';
import BaseApi from 'app/services/api/base.api';
import axios from 'axios';
import {
  AcquisitionChannelsDTO,
  FetchTopPostCodeResponse,
  FranchiseAverageBasketDTO,
  LoyaltyOffersRedeemedOutDTO,
  LoyaltyOutDTO,
  PassageFrequencyInDTO,
  RedeemedCouponsOutDTO,
  ROIFranchiseInDTO,
  TopClientsRankingsDTO,
  TransactionHistoryDayDTO,
  TransactionHistoryYearDTO,
  WeeklyCategoryBreakdownDTO,
} from '../types';

export const widgetApi = new BaseApi({ baseURL: ROUTER_API, tokenKey: 'token', timeout: 60000 });

export const getTransactionYearsHistoryApi = async (
  franchiseId: string,
  event: 'passage' | 'reclamation',
  storeId?: string,
) => {
  const response = await widgetApi.api.get<TransactionHistoryYearDTO[]>(
    `/api/v2/analytics/franchises/${franchiseId}/history/years`,
    {
      params: {
        events: event,
        storeId,
      },
    },
  );
  return response;
};

export const getTransactionDaysHistoryApi = async (
  franchiseId: string,
  event: 'passage' | 'reclamation',
  storeId?: string,
) => {
  const response = await widgetApi.api.get<TransactionHistoryDayDTO[]>(
    `/api/v2/analytics/franchises/${franchiseId}/history/days`,
    {
      params: {
        events: event,
        storeId,
      },
    },
  );
  return response;
};

export const fetchTotalCustomer = async (franchiseId: string, storeId?: string) => {
  const response = await widgetApi.api.get<number>(`api/v2/analytics/franchises/${franchiseId}/clients/count`, {
    params: {
      storeId,
    },
  });
  return response.data;
};

export const fetchTopPostCode = async ({ storeId, limitRank }: { storeId: string; limitRank: number }) =>
  axios.get<FetchTopPostCodeResponse>('/api/Analytics/topPostCode', {
    params: {
      storeId,
      limitRank,
    },
  });

export const fetchPassageFrequency = async (storeId: string, startDate?: string, endDate?: string) => {
  const response = await widgetApi.api.get<PassageFrequencyInDTO>(`api/v2/stores/${storeId}/analytics/frequency`, {
    params: {
      startDate,
      endDate,
    },
  });
  return response.data;
};

export const fetchReturns = async (storeId: string) => {
  const response = await widgetApi.api.get<number>(`/api/v2/stores/${storeId}/analytics/returns`);
  return response.data;
};

export const fetchROIFranchise = async (franchiseId: string) => {
  const response = await widgetApi.api.get<ROIFranchiseInDTO>(`api/v2/franchises/${franchiseId}/roi`);
  return response.data;
};

export const fetchLoyalty = async (
  franchiseId: string,
  startDate?: string,
  endDate?: string,
  userId?: string,
  storeId?: string,
) => {
  const response = await widgetApi.api.get<LoyaltyOutDTO>(`api/v2/franchises/${franchiseId}/analytics/loyalty-graph`, {
    params: {
      startDate,
      endDate,
      userId,
      storeId,
    },
  });
  return response.data;
};

export const fetchLoyaltyOffersRedeemed = async (
  franchiseId: string,
  storeId?: string,
  startDate?: string,
  endDate?: string,
) => {
  const response = await widgetApi.api.get<LoyaltyOffersRedeemedOutDTO[]>(
    `api/v2/analytics/franchises/${franchiseId}/loyalty-offers/redeemed`,
    {
      params: {
        storeId,
        startDate,
        endDate,
      },
    },
  );
  return response.data;
};

export const fetchRedeemedCouponsApi = async (
  franchiseId: string,
  storeId: string,
  page: number,
  size: number,
  startDate?: string,
  endDate?: string,
) => {
  const response = await widgetApi.api.get<ListObject<RedeemedCouponsOutDTO>>(
    `/api/v2/analytics/franchises/${franchiseId}/coupons/redeemed`,
    {
      params: {
        storeId,
        page,
        size,
        startDate,
        endDate,
      },
    },
  );
  return response.data;
};

export const fetchConversionRateApi = async (franchiseId: string) => {
  const response = await widgetApi.api.get<ConversionRateDTO>(
    `/api/v2/analytics/franchises/${franchiseId}/users/conversion-rate`,
  );
  return response.data;
};

export const fetchAcquisitionChannelsApi = async (franchiseId: string) => {
  const response = await widgetApi.api.get<AcquisitionChannelsDTO>(
    `/api/v2/analytics/franchises/${franchiseId}/clients/acquisition-channels`,
  );
  return response.data;
};

export const fetchTopClientsApi = async (franchiseId: string, storeId?: string) => {
  const response = await widgetApi.api.get<TopClientsRankingsDTO>(
    `/api/v2/analytics/franchises/${franchiseId}/clients/top-rankings`,
    {
      params: {
        storeId,
      },
    },
  );
  return response.data;
};

export const fetchFranchiseAverageBasketApi = async (franchiseId: string, storeId?: string) => {
  const response = await widgetApi.api.get<FranchiseAverageBasketDTO>(
    `/api/v2/analytics/franchises/${franchiseId}/average-basket`,
    {
      params: {
        storeId,
      },
    },
  );
  return response.data;
};

export const fetchCategoryBreakdownApi = async (franchiseId: string, storeId?: string) => {
  const response = await widgetApi.api.get<WeeklyCategoryBreakdownDTO[]>(
    `/api/v2/analytics/franchises/${franchiseId}/receipts/category-breakdown`,
    {
      params: {
        storeId,
      },
    },
  );
  return response.data;
};
